import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatModal = createCustomElementWrapper('kat-modal', 'KatModal', {
    'noCloseIcon': 'no-close-icon',
    'scrollAll': 'scroll-all',
}, {
    'onClose': 'close',
    'onOpen': 'open',
}, [
    'title',
    'footer',
]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/modal.js
// module id = 1278
// module chunks = 0